import { to } from 'nh-utils'
import api, { apiWithoutPropertySuffix } from 'lib/api'

export const bannerImage = async () =>
  to(apiWithoutPropertySuffix.get('home/banner'))
export const advertisingData = async () =>
  to(apiWithoutPropertySuffix.get(`/home/advertising`))
export const fetchBestSellingProperty = async () =>
  to(api.get('?most-accessed=1'))
